import mutationEvents from 'mutation-events'; // Fixes Chrome's depreciation of DOM mutation events

import SwiperInit from './swiper_init';

(() => {
  document.addEventListener('turbo:load', () => {
    SwiperInit();
  })
})();